import React, { useState } from 'react';
import { Modal, Box } from '@mui/material';
import StackedLineChartOutlinedIcon from '@mui/icons-material/StackedLineChartOutlined';
import UIRTMButton from "../UIRTMButton";
import AIAnalyticsDashboard from "./AIAnalyticsDashboard";

const AIAnalytics = ({ onFetchData, disabled, templateType }) => {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const handleOpen = async () => {
    try {
      setLoading(true);
      const issues = await onFetchData();
      setData(issues);
      setShowModal(true);
    } catch (error) {
      console.error("Failed to fetch data for AI analytics", error);
    } finally {
      setLoading(false);
    }
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "95%",
    maxWidth: "1200px",
    maxHeight: "95vh",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: 2,
    p: 0,
    overflowY: "auto",
  };

  return (
    <React.Fragment>
      <UIRTMButton
        title={loading ? "Analyzing..." : "Analytics"}
        variant="text"
        icon={<StackedLineChartOutlinedIcon sx={{ fontSize: "1rem", color: (disabled || loading) ? "inherit" : "#c610de" }} />}
        loading={loading}
        disabled={disabled || loading}
        onClick={handleOpen}
      />

      <Modal 
        open={showModal} 
        onClose={(event, reason) => {
          if (reason && (reason === 'backdropClick' || reason === 'escapeKeyDown')) {
            return;
          }
          setShowModal(false);
        }}
      >
        <Box sx={modalStyle}>
          {data && (
            <AIAnalyticsDashboard 
              data={data} 
              templateType={templateType} 
              onClose={() => setShowModal(false)} 
            />
          )}
        </Box>
      </Modal>
    </React.Fragment>
  );
};

export default AIAnalytics;
